import DOMPurify from 'dompurify'

// Sanitizes untrusted HTML (e.g. chat message content) before rendering it via v-html.
// Only basic formatting tags and safe anchor attributes are allowed;
// javascript: URIs and event handlers are stripped by DOMPurify.
export function sanitizeHtml (dirty: string): string {
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: ['a', 'b', 'strong', 'i', 'em', 'u', 's', 'br', 'p', 'ul', 'ol', 'li', 'span'],
    ALLOWED_ATTR: ['href', 'target', 'rel'],
  })
}
